// src/services/implementations/OrganizationServiceImpl.ts
import { OrganizationService } from "@/services/abstract/OrganizationService";
import type { FetcherService } from "@/services/abstract/FetcherService";
import type {
  OrgProfileDTO,
  AdminDTO,
  SeatSummaryDTO,
  OrgUserDTO,
} from "@/types/organization.dtos";
import { organizationEndpoints } from "@/services/endpoints/organization";

export class OrganizationServiceImpl extends OrganizationService {
  constructor(private readonly fetcher: FetcherService) {
    super();
  }

  // --- Organization Profile ---
  async getProfile(): Promise<OrgProfileDTO> {
    return await this.fetcher.get<OrgProfileDTO>(
      organizationEndpoints.getOrganizationProfile
    );
  }

  async getProfileById(id: string): Promise<OrgProfileDTO> {
    return await this.fetcher.get<OrgProfileDTO>(
      organizationEndpoints.getOrganizationProfileById(id)
    );
  }

  // --- Organization Admins ---
  async getAdmins(): Promise<AdminDTO[]> {
    return await this.fetcher.get<AdminDTO[]>(
      organizationEndpoints.listOrganizationAdmins
    );
  }

  // --- Seats Summary ---
  async getSeatSummary(): Promise<SeatSummaryDTO> {
    return await this.fetcher.get<SeatSummaryDTO>(
      organizationEndpoints.getOrganizationSeatSummary
    );
  }

  // --- Organization Users ---
  async getUsers(): Promise<OrgUserDTO[]> {
    return await this.fetcher.get<OrgUserDTO[]>(
      organizationEndpoints.listOrganizationUsers
    );
  }
}
